import { Vue, prop, Options } from 'vue-class-component';
import VueSlider from 'vue-slider-component';
import { WidgetWrapper } from '@/components/widget-wrapper';
import '@/styles/slider.scss';
import { Inject, Watch } from 'vue-property-decorator';
import type { VueI18n } from 'vue-i18n';
import styles from './styles.module.scss';

class CashDownSliderProps {
	loading = prop<boolean>({ default: true })

	value = prop<number>({ default: 0 })

	min = prop<number>({ default: 0 })

	max = prop<number>({ default: 1000 })

	step = prop<number>({ default: undefined })

	onChange = prop<Function>({ default: () => () => undefined })
}

@Options({
	components: {
		VueSlider,
	},
})
export class CashDownSlider extends Vue.with(CashDownSliderProps) {
	@Inject() readonly i18n!: VueI18n;

	sliderValue = this.value;

	@Watch('value')
	updateValue(value: number): void {
		this.sliderValue = value;
	}

	@Watch('sliderValue')
	handleSliderValueChange(value: number) {
		this.onChange(value);
	}

	render() {
		return (
			<WidgetWrapper
				class={styles.cashDownSlider}
				active={this.sliderValue !== 0}
				loading={this.loading}
				title={this.i18n.t('cashDown.title')} value={this.i18n.n(this.sliderValue, 'currency')}
				editIcon={true}
				unFormattedValue={this.sliderValue}
				onChange={this.updateValue}
				inputPrefix={'$'}
				min={this.min}
				max={this.max}
			>
				<vue-slider class={styles.cashDownSliderSlider} v-model={this.sliderValue} min={this.min}
					max={this.max} interval={this.step}
					dotSize={24} tooltip={'none'} silent={true}
				/>
			</WidgetWrapper>
		);
	}
}
